var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 14.6833C1.96667 14.6833 1.65267 14.5526 1.39133 14.2913C1.13044 14.0304 1 13.7166 1 13.35V4.01664C1 3.64997 1.13044 3.33597 1.39133 3.07464C1.65267 2.81375 1.96667 2.6833 2.33333 2.6833H8.28333L6.95 4.01664H2.33333V13.35H11.6667V8.71664L13 7.3833V13.35C13 13.7166 12.8696 14.0304 12.6087 14.2913C12.3473 14.5526 12.0333 14.6833 11.6667 14.6833H2.33333ZM9.78333 3.06664L10.7333 3.99997L6.33333 8.39997V9.34997H7.26667L11.6833 4.9333L12.6333 5.86664L8.21667 10.2833C8.09444 10.4055 7.95289 10.5029 7.792 10.5753C7.63067 10.6473 7.46111 10.6833 7.28333 10.6833H5.66667C5.47778 10.6833 5.31956 10.6195 5.192 10.492C5.064 10.364 5 10.2055 5 10.0166V8.39997C5 8.22219 5.03333 8.05264 5.1 7.8913C5.16667 7.73041 5.26111 7.58886 5.38333 7.46664L9.78333 3.06664ZM12.6333 5.86664L9.78333 3.06664L11.45 1.39997C11.7167 1.1333 12.0362 0.999969 12.4087 0.999969C12.7807 0.999969 13.0944 1.1333 13.35 1.39997L14.2833 2.34997C14.5389 2.60553 14.6667 2.91664 14.6667 3.2833C14.6667 3.64997 14.5389 3.96108 14.2833 4.21664L12.6333 5.86664Z",
    fill: "#654AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f2fc3f0a561079e6f19fef274f22bdf.svg";
export { ForwardRef as ReactComponent };